export const NAMES = {
  TRUSTEES_FULL_NAME: 'fullName',
  TRUSTEES_PHONE: 'phone',
  TRUSTEES_GENDER: 'gender',
  SPOUSE_FULL_NAME: 'fullName',
  SPOUSE_PHONE: 'phone',
  SPOUSE_BIRTHDAY_DATE: 'birthDate',
  SPOUSE_GENDER: 'gender',
};

export const TRUSTEES_FORM_LABELS = {
  [NAMES.TRUSTEES_PHONE]: 'Мобильный телефон',
  [NAMES.SPOUSE_BIRTHDAY_DATE]: 'Дата рождения',
  [NAMES.SPOUSE_PHONE]: 'Мобильный телефон',
};
